import { ROOT_FOLDER_NAME } from 'src/domain/files/constants';

export function getPathString(paths: string[], includeRoot = false) {
  const resultPath = includeRoot ? paths : paths.filter((p) => p !== ROOT_FOLDER_NAME);
  return resultPath.join('/');
}
